const Utils = {
    getParticipantImageFileName(image_index: number | undefined): string {
        if (image_index === undefined)
            image_index = 3; // default image index

        switch (image_index) {
            case 1:
                return "1.png";
            case 2:
                return "2.png";
            case 3:
                return "3.png";
            case 4:
                return "4.png";
            case 5:
                return "5.png";
            case 6:
                return "6.png";
            default:
                return "3.png";
        }
    },

    isActionPlanned(date?: string | null): boolean {
        if (date === undefined || date === null)
            return true;

        let theday = new Date();
        theday.setHours(0, 0, 0, 0);
        theday.setMonth(theday.getMonth() - 1);

        let datum = new Date(Date.parse(date));
        if (datum >= theday)
            return true;
        else return false;
    }
};

export default Utils;